import {createFileRoute} from '@tanstack/react-router';

import DocumentCreate from '@/patient/views/document/DocumentCreate';

export const Route = createFileRoute('/(patient)/documents/create')({
  component: DocumentCreate
});
